export default __webpack_public_path__ + "locales/de/DataReassignmentDialog.json?hash=51f62190c3ba51cadab7bfcb548fa454";